export type ComplianceActorLabel = 'OEM' | 'SUPPLIER'

export function complianceActorDisplayLabel(
  actor: ComplianceActorLabel,
  organizationName: string | null | undefined
): string {
  if (actor === 'OEM') {
    const trimmed = organizationName?.trim()
    if (trimmed != null && trimmed.length > 0) {
      return trimmed
    }
  }
  return actor
}
